import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import MetasDepartamentos from '../../components/MetasDepartamentos/MetasDepartamentos';
import NotifierPopup from '../../components/NotifierPopup/NotifierPopup';

export default function MetasDepartamentosAdm() {

    const [ notify, setNotify ] = useState({
        isActive: false,
        isSuccessful: undefined,
        message: undefined
    });


    return <>
        {notify.isActive && 
            <NotifierPopup 
                notify={notify}
                setNotify={setNotify}
            />
        }
        <MetasDepartamentos  setNotifier = {(isSuccess, message) => setNotify({
                isActive: true,
                isSuccessful: isSuccess,
                message: message
            })} />
    </>
}